import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Box } from '@mui/material';
import { keys, length } from 'ramda';
import { TextField } from '@qrios/frontend-library';
import { BusinessError } from '../../../../common/business-error';
import Divider from '../../../../common/divider/divider';
import { diffObject } from '../../../../../constants/helpers/diff';
import WithFormLayout from '../../../../common/with-form-layout';

const validationSchema = yup.object().shape({
  code: yup
    .string()
    .required('Code is required')
    .min(6, 'Code must be at least 6 characters')
    .max(6, 'Code must be most 6 characters')
});

interface Props {
  handleCloseDialog: () => void;
  handleSubmitAction: (code: string) => void;
  loading: boolean;
  error?: BusinessError | null;
}

const DialogContent = ({ handleCloseDialog, handleSubmitAction, loading, error }: Props) => (
  <Formik
    initialValues={{
      code: ''
    }}
    validationSchema={validationSchema}
    onSubmit={values => {
      handleSubmitAction(values.code);
    }}
  >
    {({ setFieldValue, values, errors, touched, handleBlur, handleSubmit }) => {
      const handleChange = (field: string, value: unknown) => {
        setFieldValue(field, value);
      };
      const valuesUnchanged = length(keys(diffObject({ code: '' }, { code: values.code }))) === 0;
      return (
        <WithFormLayout
          submitLabel="Verify Invitation Code"
          secondaryLabel="Close without update"
          onSubmit={handleSubmit}
          onSecondary={handleCloseDialog}
          loading={loading}
          error={error}
          disableSubmit={valuesUnchanged}
        >
          <Box display="flex" flexDirection="column" justifyContent="space-between">
            <Box mb={1}>
              <TextField
                name="code"
                value={values.code}
                handleChange={e => handleChange(e.target.name, e.target.value)}
                handleBlur={handleBlur}
                label=""
                data-testid="input-invitation-code"
                error={errors.code}
                touched={touched.code}
                placeholder="Invitation code"
              />
            </Box>
            <Divider />
          </Box>
        </WithFormLayout>
      );
    }}
  </Formik>
);

export default DialogContent;
